import m from 'mithril';
import { SubFsm } from 'little-fsm';
import { GuestFormSubManifest, GuestInfoForm } from '../../states/common/GuestFormSubManifest';
import { AppComponents } from '../../app_common_setup';
import { BookingSummaryCard, GuestInfo, TentativeBookingResult } from '../../Models';
import GuestDetailsFormPage from '../../components/desktop/guestinfo/GuestDetailsFormPage';


export function buildGuestFormPresenter(subFsm:SubFsm<GuestFormSubManifest>, appComponents: AppComponents): {render:() => m.Vnode} {
    let dataSource = appComponents.dataSource;
    let messageProvider = appComponents.messageProvider;

    subFsm.setEnterEffect('creating_tentative_booking',  ctx => {
        if(ctx.guestInfoForm != null){
            dataSource.createTentativeBooking(null,
                ctx.bookingSession.bookingSessionId, ctx.guestInfoForm.guestInfo, ctx.guestInfoForm.totalAdults, ctx.guestInfoForm.totalChildren, 
                ctx.guestInfoForm.specialRequest)
                .then(result => {   
                    if(result.isSuccess()){                        
                        let tentativeBookingResult:TentativeBookingResult = result.getBody();
                        console.log("Got tentative booking", tentativeBookingResult);     
                        subFsm.processEvent('tentative_booking_created', {
                            tentativeBookingResult: result.getBody()
                        })

                        let reviewUrlTemplate = appComponents.rootElement.getAttribute("data-payment-options-url-template");
                        if(reviewUrlTemplate != null) {
                            let reviewUrl = reviewUrlTemplate.replace(":id", tentativeBookingResult.tentativeBooking.tentativeBookingId);
                            window.location.replace(reviewUrl);
                        } else {
                            alert("Review URL template is not defined. Cannot proceed to payment");
                        }
                    }else{
                        alert("Failed to create tentative booking. Please start again.");
                    }                 
                });
        }
    })
    
    return {       
        render() {
            let substate = subFsm.getCurrentSubState();
            let context = subFsm.getCurrentContext();
            let bookingSummaryCard:BookingSummaryCard = BookingSummaryCard.mapToBookingSummaryCardFromBookingSession(context.bookingSession); 
            let presetCountryCode:string|null = (context.bookingSession.guestType == 'LOCAL') ? "MM" : null;

            return m("div.px-3", 
                m(GuestDetailsFormPage, {
                    messageProvider: messageProvider,
                    bookingSummaryCard: bookingSummaryCard,
                    presetCountryCode: presetCountryCode,
                    restartUrl:"#",
                    attemptingBackNav:  substate == 'confirming_exit_guest_info',
                    onSubmit: (guestInfo: GuestInfo, totalAdults:number, totalChildren:number, specialRequest:string) => {
                        subFsm.processEvent('guest_info_submitted', {
                            guestInfoForm: new GuestInfoForm(guestInfo, totalAdults, totalChildren, specialRequest)
                        })
                    },
                    onBackPressed: () => {
                        window.location.href = "/";
                    },
                    onChangeAttemptingBackNav: () => {
                        if(substate == 'showing_guest_form'){
                            subFsm.processEvent('back', {})
                        }

                        if(substate == 'confirming_exit_guest_info'){
                            subFsm.processEvent('exit_cancelled', {})
                        }
                    }
                })
            );
        }                    
    }
}